module.exports = __webpack_public_path__ + "static/3.adbb1fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/3.jpg
// module id = 699
// module chunks = 168707334958949